export const createInvalidStateError = () => new DOMException('', 'InvalidStateError');
//# sourceMappingURL=invalid-state-error.js.map